import { Router } from "router5";
import { getCurrentUserAsync } from "./services/auth";
import { getRouterStore } from "~/router";

const toLogin = () =>
  Promise.reject({
    redirect: {
      name: "login",
    },
  });

const redirectTo = (redirect: string) =>
  Promise.reject({
    redirect: {
      name: redirect,
    },
  });

export const requireUser = () => {
  return (router) => (toState, fromState) => {
    return getCurrentUserAsync().then((user) => {
      if (!user) {
        return toLogin();
      }
    });
  };
};

export const requireRole = (...roles) => {
  return (router) => (toState, fromState) => {
    return getCurrentUserAsync().then((user) => {
      if (!user) {
        return toLogin();
      }

      if (roles.indexOf(user.role) == -1) {
        return toLogin();
      }
    });
  };
};

export const requireRoleAndFeature = (role: string | string[], feature: string | string[], redirect: string) => {
  return (router) => (toState, fromState) => {
    return getCurrentUserAsync().then((user) => {
      if (!user) {
        return toLogin();
      }
      const requiredRoles = Array.isArray(role) ? role : [role];
      if (!requiredRoles?.includes(user.role)) {
        return redirectTo(redirect);
      }

      const state = getRouterStore(router);
      if (!state) {
        return redirectTo(redirect);
      }
      
      const orgFeatures = state.getState()?.shared?.information?.entities?.features;
      const requiredFeatures = Array.isArray(feature) ? feature : [feature];
      const allFeaturesIncluded = requiredFeatures?.every((f) => orgFeatures?.includes(f));

      if (!allFeaturesIncluded) {
        return redirectTo(redirect);
      }
    });
  };
};

export const requireRoleAndPermissionAndFeature = (
  role: string | string[],
  permissions: string | string[],
  feature: string | string[],
  redirect: string
) => {
  return (router) => (toState, fromState) => {
    return getCurrentUserAsync().then((user) => {
      if (!user) {
        return toLogin();
      }
      
      const requiredRoles = Array.isArray(role) ? role : [role];
      if (!requiredRoles?.includes(user.role)) {
        return redirectTo(redirect);
      }

      const requiredPermissions = Array.isArray(permissions) ? permissions : [permissions];
      const allPermissionsIncluded = requiredPermissions?.every((f) => user.permissions?.includes(f));
      if (!allPermissionsIncluded) {
        return redirectTo(redirect);
      }

      const state = getRouterStore(router);
      if (!state) {
        return redirectTo(redirect);
      }

      const orgFeatures = state.getState()?.shared?.information?.entities?.features;
      const requiredFeatures = Array.isArray(feature) ? feature : [feature];
      const allFeaturesIncluded = requiredFeatures?.every((f) => orgFeatures?.includes(f));

      if (!allFeaturesIncluded) {
        return redirectTo(redirect);
      }
    });
  };
};
